// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2_MQt","consentsList":"PatientConsents_consentsList__3toZM","consentsListEmpty":"PatientConsents_consentsListEmpty__6QD35"};